import React, { useEffect, useState } from "react";
import { KeyRound } from "lucide-react";
import { api, fmtDateTime } from "../lib/api";
import { Card, Chip } from "./ui";
import ResetLinkPanel from "./ResetLinkPanel";

/** Admin home-screen card: players who tapped "Forgot password?" and are waiting for a link. */
export default function ResetRequestsCard() {
  const [requests, setRequests] = useState([]);

  useEffect(() => {
    api.get("/password-resets/requests").then(({ data }) => setRequests(data)).catch(() => {});
  }, []);

  if (!requests.length) return null;

  return (
    <div className="px-5 mt-4" data-testid="reset-requests">
      <Card className="p-4 border-amber-200">
        <div className="flex items-center gap-2 mb-1">
          <KeyRound size={16} className="text-amber-600" />
          <div className="text-sm font-bold">Password reset requests ({requests.length})</div>
        </div>
        <div className="text-xs text-ink-muted mb-2">Generate a link and send it to the player on WhatsApp.</div>
        <div className="divide-y divide-black/[0.06]">
          {requests.map((r) => (
            <div key={r.id} className="py-3 space-y-2">
              <div className="flex items-center justify-between gap-2">
                <div className="min-w-0">
                  <div className="font-semibold truncate">{r.name}</div>
                  <div className="text-xs text-ink-muted truncate">{r.email} • asked {fmtDateTime(r.requested_at)}</div>
                </div>
                {r.status === "link_sent" && <Chip tone="success">Link sent</Chip>}
              </div>
              <ResetLinkPanel memberId={r.member_id} name={r.name} />
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
}
